import {css} from "@emotion/css";

export const styles = {
  menuButton: css`
    &.MuiButtonBase-root {
      padding: 0;
    }
  `,
};
